import { FC, PropsWithChildren, useEffect } from "react"
import { useNavigate } from "react-router"
import { AccessDeniedQueryParams } from "~/pages/AccessDenied"
import { APP_ROUTES } from "~/router"
import { ACCESS_DENIED_EVENT, getLocation, NavigationEvents } from "~/utils"

export const AccessControlLayer: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()

  // Global access denied handler
  useEffect(() => {
    const handler = () => {
      const searchParams = new URLSearchParams()
      const currentLocation = getLocation().href
      searchParams.set(AccessDeniedQueryParams.RedirectUrl, currentLocation)

      navigate(`/${APP_ROUTES.AccessDenied}?${searchParams.toString()}`, { replace: true })
    }
    NavigationEvents.on(ACCESS_DENIED_EVENT, handler)

    return () => {
      NavigationEvents.off(ACCESS_DENIED_EVENT, handler)
    }
  }, [navigate])

  return children
}
